// getters
const academicBlockProducts = state => state.academicBlockProducts

export default {
    academicBlockProducts
}



// WEBPACK FOOTER //
// ./src/store/modules/academic/block_products/getters.js